import fm from 'format-message';
import useAccountQuery from 'queries/useAccountQuery';
import BaseLink from '@activebrands/core-web/components/Link';
import { OVERLAY_ID } from '@activebrands/core-web/config/overlay';
import { useOverlaySubscriber } from '@activebrands/core-web/libs/overlay';
import { styled } from '@activebrands/core-web/libs/styletron';
import { useTypedSelector } from '@activebrands/core-web/state/store';
import { getFocusRingStyles } from '@activebrands/core-web/utils/style-functions/get-focus-styles';
import OverlayToggler from 'components/Header/OverlayToggler';
import AccountIcon from 'components/icons/AccountIcon';

const Link = styled(BaseLink, {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '10px',
    ...getFocusRingStyles(),
});

const AuthLink = props => {
    const isAuthenticated = useTypedSelector(s => s.auth.isAuthenticated);
    const isOpen = useOverlaySubscriber(OVERLAY_ID.UNAUTHENTICATED);
    const { accountPage } = useAccountQuery();

    const iconContent = (
        <AccountIcon
            $style={{
                display: 'block',
                width: ['22px', null, null, null, null, '16px'],
                height: ['22px', null, null, null, null, '16px'],
            }}
        />
    );

    if (!isAuthenticated) {
        return (
            <OverlayToggler
                aria-label={fm('Sign in')}
                isOpen={isOpen}
                overlayId={OVERLAY_ID.UNAUTHENTICATED}
                overlayProps={{ redirectUri: accountPage }}
                {...props}
            >
                {iconContent}
            </OverlayToggler>
        );
    }

    return (
        <Link to={accountPage} aria-label={fm('My pages')} {...props}>
            {iconContent}
        </Link>
    );
};

export default AuthLink;
